<template>
  <div class="p-b-25">
       <a-table :pagination='false' :loading='listLoading' bordered rowKey='id'  :columns='columns' :data-source='data'>
      </a-table>
      <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
  </div>
</template>
<script>
import { reactive, ref,toRefs } from 'vue';
// import { getPointLog } from "@/api/assets";
import { iscode } from '@/utils/app';
export default {
  setup(){
    const state=reactive({
      listLoading:false,
      total:0
    })
    let data = ref();
    let columns = [
      {
        title: "核销时间",
        dataIndex: "create_time",
        key: "create_time",
      },
        {
        title: "清零总积分",
        dataIndex: "point_total",
        key: "point_total",
      },
    ]
   const initData = async (values) => {
      // state.listLoading = true;
      //   let res = await getPointLog(values).then(res=>res.data);
      //   state.listLoading = false;
      //   if (iscode(res)) {
      //     data.value = res.data.data;
      //     state.total = res.data.total;
      //   }
      //   state.listLoading = false;
    };
    const search=({page:1,limit:10})
        // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    initData(search.value)
    return{
       ...toRefs(state),
      search,
      data,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
    }
  }
}
</script>